import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { CasosService } from '../casos/casos.service';
import { AuthenticationService } from '../core/service/auth.service';

import { Caso } from '../casos/casos.model';

// Define el tipo ModelKeys fuera de la clase
type ModelKeys = keyof Modelo;

interface Financiero {
  demanda: {
    provisionFondosSimplificado?: {
      derechosAdministracionCentroNeto: number;
      honorariosArbitrosNeto: number;
      honorarios_presidente: number;
      honorarios_coarbitro_1: number;
      honorarios_coarbitro_2: number;
      derechosAdmisionNeto: number;
      gastosArbitrosTotal: number;
      gastosArbitrajeNeto: number;
      alquilerSalasNeto: number;
      subtotal: number;
      porcentajeMostarIva: number;
      importeIvaCalculado: number;
      importeTotalProvision: number;
      provisionCadaParte: number;
    };
  } | null;
  reconvencion: {
    provisionFondosSimplificado?: {
      derechosAdministracionCentroNeto: number;
      honorariosArbitrosNeto: number;
      honorarios_presidente: number;
      honorarios_coarbitro_1: number;
      honorarios_coarbitro_2: number;
      derechosAdmisionNeto: number;
      gastosArbitrosTotal: number;
      gastosArbitrajeNeto: number;
      alquilerSalasNeto: number;
      subtotal: number;
      porcentajeMostarIva: number;
      importeIvaCalculado: number;
      importeTotalProvision: number;
      provisionCadaParte: number;
    };
  } | null;
}

// Define la interfaz Modelo para tu objeto model
interface Modelo {
  financiero: Financiero,
  impuesto_aplicable_general: string;
  porcentaje_derecho_administracion_demanda: string;
  porcentaje_honorario_arbitro_demanda: string;
  porcentaje_derecho_administracion_reconvencion: string;
  porcentaje_honorario_arbitro_reconvencion: string;
  demanda_provision_admision: string;
  demanda_imputacion_conjunta_derechos_admision: boolean;
  demanda_provision_gasto_arbitro: string;
  demanda_provision_gasto_expediente: string;
  demanda_provision_alquiler_sala: string;
  reconvencion_provision_admision: string;
  reconvencion_imputacion_conjunta_derechos_admision: boolean;
  reconvencion_provision_gasto_arbitro: string;
  reconvencion_provision_gasto_expediente: string;
  reconvencion_provision_alquiler_sala: string;
  porcentaje_pago_tribunal_presidente_demanda: string;
  porcentaje_pago_tribunal_coarbitro_1_demanda: string;
  porcentaje_pago_tribunal_coarbitro_2_demanda: string;
  porcentaje_pago_tribunal_presidente_reconvencion: string;
  porcentaje_pago_tribunal_coarbitro_1_reconvencion: string;
  porcentaje_pago_tribunal_coarbitro_2_reconvencion: string;
  porcentaje_pago_demandantes_demanda: string;
  porcentaje_pago_demandados_demanda: string;
  porcentaje_pago_demandantes_reconvencion: string;
  porcentaje_pago_demandados_reconvencion: string;
  calculadora: string;
  cuantia_demanda: string;
  cuantia_reconvencion: string;
}

@Component({
  selector: 'app-gestion-financiero',
  templateUrl: './gestion.component.html',
  styleUrls: ['./gestion.component.scss']
})
export class GestionComponentFinanciero implements OnInit {

  @Output() refreshCase = new EventEmitter<void>();

  currentSection: number = 1;
  innerCurrentSection: number = 1;

  id_caso!: string | null;
  caso!: Caso;
  loaded: boolean = false;

  estadoExpediente: string | undefined;
  disableOptions: boolean = true;

  filteredFinancieroDescripcion: string[] = [];

  // Define el modelo según la interfaz Modelo
  model: Modelo = {
    financiero: {
      demanda: {
        provisionFondosSimplificado: {
          derechosAdministracionCentroNeto: 0,
          honorariosArbitrosNeto: 0,
          honorarios_presidente: 0,
          honorarios_coarbitro_1: 0,
          honorarios_coarbitro_2: 0,
          derechosAdmisionNeto: 0,
          gastosArbitrosTotal: 0,
          gastosArbitrajeNeto: 0,
          alquilerSalasNeto: 0,
          subtotal: 0,
          porcentajeMostarIva: 0,
          importeIvaCalculado: 0,
          importeTotalProvision: 0,
          provisionCadaParte: 0,
        }
      },
      reconvencion: {
        provisionFondosSimplificado: {
          derechosAdministracionCentroNeto: 0,
          honorariosArbitrosNeto: 0,
          honorarios_presidente: 0,
          honorarios_coarbitro_1: 0,
          honorarios_coarbitro_2: 0,
          derechosAdmisionNeto: 0,
          gastosArbitrosTotal: 0,
          gastosArbitrajeNeto: 0,
          alquilerSalasNeto: 0,
          subtotal: 0,
          porcentajeMostarIva: 0,
          importeIvaCalculado: 0,
          importeTotalProvision: 0,
          provisionCadaParte: 0,
        }
      }
    },
    impuesto_aplicable_general: '21',
    porcentaje_derecho_administracion_demanda: '',
    porcentaje_honorario_arbitro_demanda: '',
    porcentaje_derecho_administracion_reconvencion: '',
    porcentaje_honorario_arbitro_reconvencion: '',
    demanda_provision_admision: '',
    demanda_imputacion_conjunta_derechos_admision: false,
    demanda_provision_gasto_arbitro: '',
    demanda_provision_gasto_expediente: '',
    demanda_provision_alquiler_sala: '',
    reconvencion_provision_admision: '',
    reconvencion_imputacion_conjunta_derechos_admision: false,
    reconvencion_provision_gasto_arbitro: '',
    reconvencion_provision_gasto_expediente: '',
    reconvencion_provision_alquiler_sala: '',
    porcentaje_pago_tribunal_presidente_demanda: '40',
    porcentaje_pago_tribunal_coarbitro_1_demanda: '30',
    porcentaje_pago_tribunal_coarbitro_2_demanda: '30',
    porcentaje_pago_tribunal_presidente_reconvencion: '40',
    porcentaje_pago_tribunal_coarbitro_1_reconvencion: '30',
    porcentaje_pago_tribunal_coarbitro_2_reconvencion: '30',
    porcentaje_pago_demandantes_demanda: '50',
    porcentaje_pago_demandados_demanda: '50',
    porcentaje_pago_demandantes_reconvencion: '50',
    porcentaje_pago_demandados_reconvencion: '50',
    calculadora: '',
    cuantia_demanda: '',
    cuantia_reconvencion: ''
  };

  constructor(
    private casoService: CasosService,
    private route: ActivatedRoute,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.id_caso = this.route.snapshot.paramMap.get('id');
    if (this.id_caso) {
      this.casoService.getCaso(this.id_caso).subscribe(
        (caso) => {

          this.authService.currentUser().subscribe(user => {
            if (user?.nivel_acceso) {

              // Si soy admin no deshabilito opciones
              if (user.nivel_acceso == "ADMIN") {
                this.disableOptions = false;
              }
            }
          });


          this.caso = caso;
          this.estadoExpediente = caso.estado;
          this.model.impuesto_aplicable_general = caso.impuesto_aplicable_general != null ? caso.impuesto_aplicable_general.toString() : '';
          this.model.porcentaje_derecho_administracion_demanda = caso.porcentaje_derecho_administracion_demanda != null ? caso.porcentaje_derecho_administracion_demanda.toString() : '';
          this.model.porcentaje_honorario_arbitro_demanda = caso.porcentaje_honorario_arbitro_demanda != null ? caso.porcentaje_honorario_arbitro_demanda.toString() : '';
          this.model.porcentaje_derecho_administracion_reconvencion = caso.porcentaje_derecho_administracion_reconvencion != null ? caso.porcentaje_derecho_administracion_reconvencion.toString() : '';
          this.model.porcentaje_honorario_arbitro_reconvencion = caso.porcentaje_honorario_arbitro_reconvencion != null ? caso.porcentaje_honorario_arbitro_reconvencion.toString() : '';

          this.model.demanda_provision_admision = caso.demanda_provision_admision != null ? this.getFormattedValue(caso.demanda_provision_admision) : '';
          this.model.demanda_provision_gasto_arbitro = caso.demanda_provision_gasto_arbitro != null ? this.getFormattedValue(caso.demanda_provision_gasto_arbitro) : '';
          this.model.demanda_provision_gasto_expediente = caso.demanda_provision_gasto_expediente != null ? this.getFormattedValue(caso.demanda_provision_gasto_expediente) : '';
          this.model.demanda_provision_alquiler_sala = caso.demanda_provision_alquiler_sala != null ? this.getFormattedValue(caso.demanda_provision_alquiler_sala) : '';

          this.model.reconvencion_provision_admision = caso.reconvencion_provision_admision != null ? this.getFormattedValue(caso.reconvencion_provision_admision) : '';
          this.model.reconvencion_provision_gasto_arbitro = caso.reconvencion_provision_gasto_arbitro != null ? this.getFormattedValue(caso.reconvencion_provision_gasto_arbitro) : '';
          this.model.reconvencion_provision_gasto_expediente = caso.reconvencion_provision_gasto_expediente != null ? this.getFormattedValue(caso.reconvencion_provision_gasto_expediente) : '';
          this.model.reconvencion_provision_alquiler_sala = caso.reconvencion_provision_alquiler_sala != null ? this.getFormattedValue(caso.reconvencion_provision_alquiler_sala) : '';

          this.model.porcentaje_pago_tribunal_presidente_demanda = caso.porcentaje_pago_tribunal_presidente_demanda != null ? caso.porcentaje_pago_tribunal_presidente_demanda.toString() : '';
          this.model.porcentaje_pago_tribunal_coarbitro_1_demanda = caso.porcentaje_pago_tribunal_coarbitro_1_demanda != null ? caso.porcentaje_pago_tribunal_coarbitro_1_demanda.toString() : '';
          this.model.porcentaje_pago_tribunal_coarbitro_2_demanda = caso.porcentaje_pago_tribunal_coarbitro_2_demanda != null ? caso.porcentaje_pago_tribunal_coarbitro_2_demanda.toString() : '';

          this.model.porcentaje_pago_tribunal_presidente_reconvencion = caso.porcentaje_pago_tribunal_presidente_reconvencion != null ? caso.porcentaje_pago_tribunal_presidente_reconvencion.toString() : '';
          this.model.porcentaje_pago_tribunal_coarbitro_1_reconvencion = caso.porcentaje_pago_tribunal_coarbitro_1_reconvencion != null ? caso.porcentaje_pago_tribunal_coarbitro_1_reconvencion.toString() : '';
          this.model.porcentaje_pago_tribunal_coarbitro_2_reconvencion = caso.porcentaje_pago_tribunal_coarbitro_2_reconvencion != null ? caso.porcentaje_pago_tribunal_coarbitro_2_reconvencion.toString() : '';

          this.model.porcentaje_pago_demandantes_demanda = caso.porcentaje_pago_demandantes_demanda != null ? caso.porcentaje_pago_demandantes_demanda.toString() : '';
          this.model.porcentaje_pago_demandados_demanda = caso.porcentaje_pago_demandados_demanda != null ? caso.porcentaje_pago_demandados_demanda.toString() : '';
          this.model.porcentaje_pago_demandantes_reconvencion = caso.porcentaje_pago_demandantes_reconvencion != null ? caso.porcentaje_pago_demandantes_reconvencion.toString() : '';
          this.model.porcentaje_pago_demandados_reconvencion = caso.porcentaje_pago_demandados_reconvencion != null ? caso.porcentaje_pago_demandados_reconvencion.toString() : '';

          this.model.calculadora = caso.calculadora;
          this.model.cuantia_demanda = caso.cuantia_demanda != null ? this.getFormattedValue(caso.cuantia_demanda) : '';
          this.model.cuantia_reconvencion = caso.cuantia_reconvencion != null ? this.getFormattedValue(caso.cuantia_reconvencion) : '';

          this.model.demanda_imputacion_conjunta_derechos_admision = caso.demanda_imputacion_conjunta_derechos_admision ?? false;
          this.model.reconvencion_imputacion_conjunta_derechos_admision = caso.reconvencion_imputacion_conjunta_derechos_admision ?? false;

          this.model.financiero = {
            demanda: caso.financiero?.demanda ? {
              provisionFondosSimplificado: {
                derechosAdministracionCentroNeto: caso.financiero.demanda.provisionFondosSimplificado?.derechosAdministracionCentroNeto ?? 0,
                honorariosArbitrosNeto: caso.financiero.demanda.provisionFondosSimplificado?.honorariosArbitrosNeto ?? 0,
                honorarios_presidente: caso.financiero.demanda.provisionFondosSimplificado?.honorarios_presidente ?? 0,
                honorarios_coarbitro_1: caso.financiero.demanda.provisionFondosSimplificado?.honorarios_coarbitro_1 ?? 0,
                honorarios_coarbitro_2: caso.financiero.demanda.provisionFondosSimplificado?.honorarios_coarbitro_2 ?? 0,
                derechosAdmisionNeto: caso.financiero.demanda.provisionFondosSimplificado?.derechosAdmisionNeto ?? 0,
                gastosArbitrosTotal: caso.financiero.demanda.provisionFondosSimplificado?.gastosArbitrosTotal ?? 0,
                gastosArbitrajeNeto: caso.financiero.demanda.provisionFondosSimplificado?.gastosArbitrajeNeto ?? 0,
                alquilerSalasNeto: caso.financiero.demanda.provisionFondosSimplificado?.alquilerSalasNeto ?? 0,
                subtotal: caso.financiero.demanda.provisionFondosSimplificado?.subtotal ?? 0,
                porcentajeMostarIva: caso.financiero.demanda.provisionFondosSimplificado?.porcentajeMostarIva ?? 0,
                importeIvaCalculado: caso.financiero.demanda.provisionFondosSimplificado?.importeIvaCalculado ?? 0,
                importeTotalProvision: caso.financiero.demanda.provisionFondosSimplificado?.importeTotalProvision ?? 0,
                provisionCadaParte: caso.financiero.demanda.provisionFondosSimplificado?.provisionCadaParte ?? 0,
              }
            } : null,

            reconvencion: caso.financiero?.reconvencion ? {
              provisionFondosSimplificado: {
                derechosAdministracionCentroNeto: caso.financiero.reconvencion.provisionFondosSimplificado?.derechosAdministracionCentroNeto ?? 0,
                honorariosArbitrosNeto: caso.financiero.reconvencion.provisionFondosSimplificado?.honorariosArbitrosNeto ?? 0,
                honorarios_presidente: caso.financiero.reconvencion.provisionFondosSimplificado?.honorarios_presidente ?? 0,
                honorarios_coarbitro_1: caso.financiero.reconvencion.provisionFondosSimplificado?.honorarios_coarbitro_1 ?? 0,
                honorarios_coarbitro_2: caso.financiero.reconvencion.provisionFondosSimplificado?.honorarios_coarbitro_2 ?? 0,
                derechosAdmisionNeto: caso.financiero.reconvencion.provisionFondosSimplificado?.derechosAdmisionNeto ?? 0,
                gastosArbitrosTotal: caso.financiero.reconvencion.provisionFondosSimplificado?.gastosArbitrosTotal ?? 0,
                gastosArbitrajeNeto: caso.financiero.reconvencion.provisionFondosSimplificado?.gastosArbitrajeNeto ?? 0,
                alquilerSalasNeto: caso.financiero.reconvencion.provisionFondosSimplificado?.alquilerSalasNeto ?? 0,
                subtotal: caso.financiero.reconvencion.provisionFondosSimplificado?.subtotal ?? 0,
                porcentajeMostarIva: caso.financiero.reconvencion.provisionFondosSimplificado?.porcentajeMostarIva ?? 0,
                importeIvaCalculado: caso.financiero.reconvencion.provisionFondosSimplificado?.importeIvaCalculado ?? 0,
                importeTotalProvision: caso.financiero.reconvencion.provisionFondosSimplificado?.importeTotalProvision ?? 0,
                provisionCadaParte: caso.financiero.reconvencion.provisionFondosSimplificado?.provisionCadaParte ?? 0,
              }
            } : null
          };

          if (Array.isArray(this.caso['financiero_descripcion'])) {
            this.filteredFinancieroDescripcion = (this.caso['financiero_descripcion'] as Array<any>).filter(
              (item: any): item is string => typeof item === 'string'
            );
          }

          this.loaded = true;


        },
        (error) => {
          console.error('Error obteniendo el caso:', error);
        }
      );
    }
  }


  isCaseClosed(): boolean {
    const estadosCerrados = ['CERRADO_LAUDO', 'CERRADO_ACUERDO', 'CERRADO_OTROS', 'CERRADO_REENVIO'];
    return estadosCerrados.includes(this.estadoExpediente ?? '');
  }


  onFocus(field: { [K in keyof Modelo]: Modelo[K] extends string ? K : never }[keyof Modelo]): void {
    // Accede solo a los campos que son strings
    this.model[field] = this.model[field].replace(/\./g, '').replace(' €', '');
  }

  onBlur(field: { [K in keyof Modelo]: Modelo[K] extends string ? K : never }[keyof Modelo]): void {
    const value = parseFloat(this.model[field].replace(',', '.'));
    if (!isNaN(value)) {
      this.model[field] = this.getFormattedValue(value);
    }
  }

  hasReconvencion(): boolean {
    const cuantiaReconvencion = parseFloat(this.removeFormattedValue(this.model.cuantia_reconvencion || '0'));
    return !isNaN(cuantiaReconvencion) && cuantiaReconvencion > 0;
  }



  removeFormattedValue(value: string): string {
    // Elimina los puntos como separadores de miles
    let result = value.replace(/\./g, '');

    // Reemplaza la coma con un punto para el formato decimal
    result = result.replace(',', '.');

    // Elimina el símbolo de €
    result = result.replace(' €', '');

    return result;
  }


  getFormattedValue(value: number): string {
    return value.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  onSubmit(f: NgForm) {
    if (this.id_caso) {
      const updatedFields: Caso = {
        impuesto_aplicable_general: parseFloat(this.model.impuesto_aplicable_general) || '0',
        porcentaje_derecho_administracion_demanda: parseFloat(this.model.porcentaje_derecho_administracion_demanda) || '0',
        porcentaje_honorario_arbitro_demanda: parseFloat(this.model.porcentaje_honorario_arbitro_demanda) || '0',
        porcentaje_derecho_administracion_reconvencion: parseFloat(this.model.porcentaje_derecho_administracion_reconvencion) || '0',
        porcentaje_honorario_arbitro_reconvencion: parseFloat(this.model.porcentaje_honorario_arbitro_reconvencion) || '0',
        demanda_provision_admision: parseFloat(this.removeFormattedValue(this.model.demanda_provision_admision)) || '0',
        demanda_provision_gasto_arbitro: parseFloat(this.removeFormattedValue(this.model.demanda_provision_gasto_arbitro)) || '0',
        demanda_provision_gasto_expediente: parseFloat(this.removeFormattedValue(this.model.demanda_provision_gasto_expediente)) || '0',
        demanda_provision_alquiler_sala: parseFloat(this.removeFormattedValue(this.model.demanda_provision_alquiler_sala)) || '0',
        reconvencion_provision_admision: parseFloat(this.removeFormattedValue(this.model.reconvencion_provision_admision)) || '0',
        reconvencion_provision_gasto_arbitro: parseFloat(this.removeFormattedValue(this.model.reconvencion_provision_gasto_arbitro)) || '0',
        reconvencion_provision_gasto_expediente: parseFloat(this.removeFormattedValue(this.model.reconvencion_provision_gasto_expediente)) || '0',
        reconvencion_provision_alquiler_sala: parseFloat(this.removeFormattedValue(this.model.reconvencion_provision_alquiler_sala)) || '0',
        porcentaje_pago_tribunal_presidente_demanda: parseFloat(this.model.porcentaje_pago_tribunal_presidente_demanda) || '0',
        porcentaje_pago_tribunal_coarbitro_1_demanda: parseFloat(this.model.porcentaje_pago_tribunal_coarbitro_1_demanda) || '0',
        porcentaje_pago_tribunal_coarbitro_2_demanda: parseFloat(this.model.porcentaje_pago_tribunal_coarbitro_2_demanda) || '0',
        porcentaje_pago_tribunal_presidente_reconvencion: parseFloat(this.model.porcentaje_pago_tribunal_presidente_reconvencion) || '0',
        porcentaje_pago_tribunal_coarbitro_1_reconvencion: parseFloat(this.model.porcentaje_pago_tribunal_coarbitro_1_reconvencion) || '0',
        porcentaje_pago_tribunal_coarbitro_2_reconvencion: parseFloat(this.model.porcentaje_pago_tribunal_coarbitro_2_reconvencion) || '0',
        porcentaje_pago_demandantes_demanda: parseFloat(this.model.porcentaje_pago_demandantes_demanda) || '0',
        porcentaje_pago_demandados_demanda: parseFloat(this.model.porcentaje_pago_demandados_demanda) || '0',
        porcentaje_pago_demandantes_reconvencion: parseFloat(this.model.porcentaje_pago_demandantes_reconvencion) || '0',
        porcentaje_pago_demandados_reconvencion: parseFloat(this.model.porcentaje_pago_demandados_reconvencion) || '0',
        calculadora: this.model.calculadora,
        cuantia_demanda: parseFloat(this.removeFormattedValue(this.model.cuantia_demanda)) || '0',
        cuantia_reconvencion: parseFloat(this.removeFormattedValue(this.model.cuantia_reconvencion)) || '0',
        numero_expediente: this.caso.numero_expediente,
        demanda_imputacion_conjunta_derechos_admision: this.model.demanda_imputacion_conjunta_derechos_admision,
        reconvencion_imputacion_conjunta_derechos_admision: this.model.reconvencion_imputacion_conjunta_derechos_admision
        //fecha_solicitud: this.caso.fecha_solicitud
      };

      //console.log("updatedFields", updatedFields)

      this.casoService.updateCaso(this.id_caso, updatedFields).subscribe(
        (res) => {
          this.refreshCase.emit();
          this.ngOnInit(); // Refresco el caso por los datos de Provisión de fondos
        },
        (error) => {
          //console.log("updatedFields",updatedFields)
        }
      );

    }
  }

  getArbitroRolNombre(rol: string): string {
    const participante = this.caso?.participantes?.find(p => p.arbitro_rol === rol);
    return participante ? `(${participante.usuario.nombre} ${participante.usuario.apellidos})` : '';
  }

}
